import {Roles} from '@myfm/domain';

export type AuditEvent={id:string;old_value?:unknown;new_value?:unknown;occurred_at:string;actor_name?:string|null;actor_role?:string|null;action:string;entity_type:string;entity_id?:string|null;workflow_stage?:string|null;reason?:string|null;source_system?:string|null;correlation_id?:string|null;approval_id?:string|null};
export function isAutomation(event:AuditEvent){return event.actor_role===Roles.IntegrationService;}
/** Unknown actor roles stay visible with the main history; names never imply automation. */
export function auditAutomationGroups(events:readonly AuditEvent[]){
 const groups=new Map<string,{key:string;action:string;entityType:string;source:string;events:AuditEvent[]}>();
 for(const event of events){
  if(!isAutomation(event))continue;
  const source=event.source_system??'Source not recorded';
  const key=JSON.stringify([event.action,event.entity_type,source]);
  const group=groups.get(key)??{key,action:event.action,entityType:event.entity_type,source,events:[]};
  group.events.push(event);groups.set(key,group);
 }
 return [...groups.values()];
}
